import { useAuth } from "../../context/AuthContext";

// Branch origin badge — shows which branch a record belongs to
export function BranchBadge({ branchName, isMyBranch, compact = false }) {
  if (!branchName) return null;
  return (
    <span style={{
      display: "inline-flex",
      alignItems: "center",
      gap: 4,
      padding: compact ? "2px 7px" : "3px 9px",
      borderRadius: 20,
      fontSize: compact ? 10 : 11,
      fontWeight: 700,
      fontFamily: "'DM Mono', monospace",
      whiteSpace: "nowrap",
      background: isMyBranch ? "rgba(245,166,35,0.12)" : "rgba(90,90,114,0.15)",
      border: `1px solid ${isMyBranch ? "rgba(245,166,35,0.3)" : "rgba(90,90,114,0.25)"}`,
      color: isMyBranch ? "var(--accent)" : "var(--text3)",
    }}>
      {isMyBranch ? "⚡" : "🏢"} {branchName}
    </span>
  );
}

// Tabs for My Branch / Other Branches — only renders for branch_managers
export function BranchTabs({ activeTab, onChange, myCount, otherCount }) {
  const { user } = useAuth();
  if (user?.role !== "branch_manager") return null;

  return (
    <div style={{ display: "flex", gap: 4, marginBottom: 16, background: "var(--bg3)", padding: 4, borderRadius: 10, width: "fit-content" }}>
      <TabBtn
        active={activeTab === "mine"}
        onClick={() => onChange("mine")}
        label="My Branch"
        count={myCount}
        color="var(--accent)"
      />
      <TabBtn
        active={activeTab === "others"}
        onClick={() => onChange("others")}
        label="Other Branches"
        count={otherCount}
        color="var(--text3)"
      />
      <TabBtn
        active={activeTab === "all"}
        onClick={() => onChange("all")}
        label="All"
        count={myCount + otherCount}
        color="var(--blue)"
      />
    </div>
  );
}

function TabBtn({ active, onClick, label, count, color }) {
  return (
    <button
      onClick={onClick}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 6,
        padding: "7px 14px",
        borderRadius: 8,
        border: "none",
        cursor: "pointer",
        fontFamily: "inherit",
        fontSize: 13,
        fontWeight: 700,
        background: active ? "var(--bg2)" : "transparent",
        color: active ? "var(--text)" : "var(--text3)",
        boxShadow: active ? "0 1px 4px rgba(0,0,0,0.3)" : "none",
        transition: "all 0.15s",
      }}
    >
      {label}
      <span style={{
        background: active ? color : "var(--bg3)",
        color: active ? (color === "var(--text3)" ? "var(--text)" : "#000") : "var(--text3)",
        borderRadius: 10,
        padding: "1px 7px",
        fontSize: 11,
        fontWeight: 800,
        minWidth: 20,
        textAlign: "center",
      }}>
        {count}
      </span>
    </button>
  );
}

// Hook: splits any array of records into mine / others based on is_my_branch flag
export function useBranchSplit(records, activeTab) {
  const mine   = records.filter(r => r.is_my_branch === 1 || r.is_my_branch === true);
  const others = records.filter(r => !r.is_my_branch);
  const visible = activeTab === "mine" ? mine : activeTab === "others" ? others : records;
  return { mine, others, visible };
}
